// Registry for route data resolvers
import { resolvers } from './data-resolvers';
import { registerRouteResolver } from './route-resolvers';

/**
 * Initialize and register all data resolvers for routes
 * This function should be called when the app starts
 */
export function initializeRouteResolvers(): void {
  registerRouteResolver('biorganic-report', resolvers.combine(
    resolvers.productStringFilter,
    resolvers.seasonStringFilter,
    resolvers.documentTypeFilter
  ));

  registerRouteResolver('proccess', resolvers.combine(
    resolvers.groupStructuresDefault,
    resolvers.groupStructuresByCompany,
    resolvers.storageTypesByCompany
  ));
  
  // Register resolver for integrations routes
  registerRouteResolver('integrations', resolvers.integrationResolver);
  
  console.log('Route resolvers registered successfully');
}